import HeaderBar from './header-bar'
export default HeaderBar



// WEBPACK FOOTER //
// ./src/view/main/components/header-bar/index.js